/**
 * Chunks an array into small arrays
 * @param {array} source Original array which you wish to split into chunks
 * @param {number} chunkSize The amount of items in an array
 * @returns An array which contains arrays of chunkSize.
 */
export const chunk = (source, chunkSize) => {
  return source.reduce((resultArray, item, index) => {
    const chunkIndex = Math.floor(index / chunkSize)

    if (!resultArray[chunkIndex]) {
      resultArray[chunkIndex] = [] // start a new chunk
    }

    resultArray[chunkIndex].push(item)

    return resultArray
  }, [])
}
